import { RootState } from "store/store"
import { selectUser } from "../store/sessionSlice"
import { reportApi } from "./api"

export const activeMembershipApi = reportApi.injectEndpoints({
  endpoints: (builder) => ({
    switchActiveMembership: builder.mutation<unknown, string>({
      queryFn: async (targetOrgId, api, _extraOptions, baseQuery) => {
        const user = selectUser(api.getState() as RootState)
        if (!user?.id) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: "Unable to get current user ID from session state",
            },
          }
        }

        const targetOrg = user.cross_org.find((org) => org.id === targetOrgId)
        if (!targetOrg) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: "Target organization not found in user's memberships",
            },
          }
        }

        const body = {
          data: {
            id: user.id,
            type: "user--user",
            relationships: {
              field_active_membership: {
                data: {
                  type: targetOrg.type,
                  id: targetOrg.id,
                },
              },
            },
          },
        }

        const response = await baseQuery({
          url: `/user/user/${user.id}`,
          method: "PATCH",
          body,
          headers: {
            "Content-Type": "application/vnd.api+json",
            Accept: "application/vnd.api+json",
          },
        })

        if (response.error) {
          return { error: response.error }
        }

        return { data: response.data }
      },
    }),
  }),
})

export const { useSwitchActiveMembershipMutation } = activeMembershipApi
